import ShareButton from './ShareButton';

export default ShareButton;



// WEBPACK FOOTER //
// ./src/components/ShareButton/index.js